export const environment = {
  production: true,
  apiUrl: '/aliss-frontend/ws/api/handler/chat/v1',
  apiProcessorUrl: '/aliss-frontend/ws/api/processor/v1',
  apiEmailFromUrl: '/aliss-frontend/ws/api/handler/emailform/v1',
  apiMenuArbolUrl: '/aliss-frontend/ws/api/handler/menuarbol/v1',
  apiMenuUrl: '/aliss-frontend/ws/api/handler/menu/v1',
  apiDestinatariosUrl: '/aliss-frontend/ws/api/handler/destinatarios/v1',
  apiSecurityUrl: '/aliss-frontend/ws/api/handler/security/v1',
  pollTime: 2000,
  domain:'bps.gub.uy'
};